import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import TabsFooter from '../TabsFooter/TabsFooter';
import { SHIPMENT_URLS, CLIENT_URLS, CARRIER_URLS, INVOICE_URLS } from '../../config/routeUrls';
import './doublePageContainer.css';

export default function DoublePageContainer({ data_type, showTabsFooter }) {
  let links;

  if (data_type === 'shipment') {
    links = [
      { text: 'NOUVEAU', url: SHIPMENT_URLS.NOUVEAU, style: '' },
      { text: 'A TRAITER', url: SHIPMENT_URLS.A_TRAITER, style: '' },
      { text: 'EN COURS', url: SHIPMENT_URLS.EN_COURS, style: '' },
      { text: 'LIVRÉ', url: SHIPMENT_URLS.LIVRE, style: '' },
      { text: 'PRÉ-FAC', url: SHIPMENT_URLS.PRE_FAC, style: '' },
      { text: 'TOUS', url: SHIPMENT_URLS.TOUS, style: '' },
      { text: 'SUPPRIMÉS', url: SHIPMENT_URLS.SUPPRIMES, style: 'tabs-footer-deleted' },
    ];
  } else if (data_type === 'client') {
    links = [
      { text: 'NOUVEAU CLI', url: CLIENT_URLS.NOUVEAU, style: '' },
      { text: 'TOUS', url: CLIENT_URLS.TOUS, style: '' },
    ];
  } else if (data_type === 'carrier') {
    links = [
      { text: 'NOUVEAU TPS', url: CARRIER_URLS.NOUVEAU, style: '' },
      { text: 'TOUS', url: CARRIER_URLS.TOUS, style: '' },
    ];
  } else if (data_type === 'invoice') {
    links = [
      { text: 'TOUTES', url: INVOICE_URLS.TOUTES, style: '' },
      { text: 'AVOIRS', url: INVOICE_URLS.AVOIRS, style: '' },
    ];
  } else if (data_type === 'stats') {
    links = [
      { text: 'CA & Marge', url: '/stats/ca-marge/', style: '' },
      { text: 'Nb dossiers', url: '/stats/nb-dossiers', style: '' },
      { text: 'Clients', url: '/stats/clients', style: '' },
      // { text: 'Litiges', url: '/stats/litiges', style: '' },
    ];
  }
  const [showSidebar, setShowSidebar] = useState(true);
  const containerClass = showSidebar ? '' : 'tabs-footer-hidden';

  const handleHide = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className={`doublePageContainer ${containerClass}`}>
      <div className="content">
        <Outlet />
      </div>
      {showTabsFooter && (
        <div className={`tabs-footer`}>
          <TabsFooter links={links} onClassChange={handleHide} />
        </div>
      )}
    </div>
  );
}
